export default "__VITE_ASSET__iDFN1gRF__"